/* ADVPRO product manual interactions — shared by every manual page */
(function(){
  document.querySelectorAll('.advm').forEach(function(root){
    var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
    // table of contents: jump + highlight current section
    var links=[].slice.call(root.querySelectorAll('.am-toc a'));
    links.forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();var s=document.getElementById(a.dataset.sec);if(s)s.scrollIntoView({behavior:reduce?'auto':'smooth'});});});
    function spy(){
      if(!links.length)return; var cur=links[0];
      links.forEach(function(l){var s=document.getElementById(l.dataset.sec);if(s&&s.getBoundingClientRect().top<180)cur=l;});
      var last=root.querySelector('.am-sec:last-of-type'); if(last&&last.getBoundingClientRect().bottom<innerHeight)cur=links[links.length-1];
      links.forEach(function(l){l.classList.toggle('am-on',l===cur);});
      if(matchMedia('(max-width:880px)').matches){cur.parentElement.scrollTo({left:cur.offsetLeft-16});}
    }
    addEventListener('scroll',spy,{passive:true}); spy();
    // app feature tabs
    root.querySelectorAll('.am-apptabs').forEach(function(bar){
      var btns=[].slice.call(bar.querySelectorAll('button'));
      btns.forEach(function(b){b.addEventListener('click',function(){btns.forEach(function(x){var on=x===b;x.setAttribute('aria-selected',on);document.getElementById(x.dataset.tab).hidden=!on;});});});
    });
    // tap a part to show its description
    root.querySelectorAll('.am-parts button').forEach(function(b){b.addEventListener('click',function(){b.setAttribute('aria-expanded',b.getAttribute('aria-expanded')!=='true');});});
    // setup step checklist
    root.querySelectorAll('.am-steps').forEach(function(list){
      var prog=list.closest('.am-sec').querySelector('[data-progress] b');
      list.querySelectorAll('.am-done').forEach(function(btn){btn.addEventListener('click',function(){
        var d=btn.closest('.am-step').classList.toggle('am-is-done');
        btn.textContent=d?'✓ Done':'Mark done';
        if(prog)prog.textContent=list.querySelectorAll('.am-is-done').length;
      });});
    });
    // tap an image to enlarge
    var lb=root.querySelector('.am-lb'); if(!lb)return;
    var lbi=lb.querySelector('img'), lbp=lb.querySelector('p');
    root.querySelectorAll('[data-zoom]').forEach(function(f){f.addEventListener('click',function(){
      var img=f.querySelector('img'); lbi.src=img.currentSrc||img.src; lbi.alt=img.alt;
      var cap=f.querySelector('figcaption'); lbp.textContent=cap?cap.textContent:'';
      if(typeof lb.showModal==='function')lb.showModal(); else {lb.setAttribute('open','');lb.classList.add('am-fb');}
    });});
    lb.addEventListener('click',function(){if(typeof lb.close==='function'&&!lb.classList.contains('am-fb'))lb.close();else{lb.removeAttribute('open');lb.classList.remove('am-fb');}});
  });
})();
